import { useMemo } from 'react';
import { useAuthContext } from '@/auth/useAuthContext';
import { hasProductsV2 } from '@/utils/productsFlow';

/**
 * Hook centralizado para detectar a versão do fluxo de produtos.
 *
 * Delega a `hasProductsV2` (`@/utils/productsFlow`), que hoje responde V2 para toda conta.
 *
 * @returns {{ version: 'v1' | 'v2', isV2: boolean }}
 *
 * @example
 * const { version, isV2 } = useProductFlowVersion();
 *
 * if (isV2) {
 *   // Usa fluxo v2
 * } else {
 *   // Usa fluxo v1 (legado)
 * }
 */
export function useProductFlowVersion() {
  const { user } = useAuthContext();

  return useMemo(() => {
    const isV2 = hasProductsV2(user);

    return {
      version: isV2 ? 'v2' : 'v1',
      isV2,
    };
  }, [user]);
}

export default useProductFlowVersion;

